import { useQuery } from "@tanstack/react-query";

import { getMaintenanceNotifications } from "../../services/notificationService";

const useGetMaintanceAnnouncement = () => {
  const query = useQuery({
    queryKey: ["maintenanceAnnouncement"],
    queryFn: getMaintenanceNotifications,
    refetchInterval: 15 * 60 * 1000, // Refetch every 15 minute
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    meta: {
      disabledGlobalToast: true,
    },
  });

  return query;
};

export default useGetMaintanceAnnouncement;
